export { default as CommentSubmitted } from './comment-submitted';
